export const routes = {
  $root: '/',
  tickets: '/tickets',
  ticket: '/tickets/:ticketId',
  chats: '/chats',
  chat: '/chats/:chatId',
  articles: '/articles-and-guides',
  articlesCategory: '/articles-and-guides/:category',
  articlesTopic: '/articles-and-guides/:category/:topic',
  faq: '/faq',
  faqCategory: 'faq/:category',
  faqTopic: 'faq/:category/:topic',
  releaseNotes: '/release-notes',
  releaseNote: '/release-notes/:slug',
  search: '/search',
  customerEffort: '/thank-you-for-your-feedback',
  staticDemo: '/static-demo',
  staticDemoChat: '/static-demo/chat',
  staticDemoEndChatModal: '/static-demo/end-chat-modal',
  staticDemoFeedbackChatModal: '/static-demo/feedback-chat-modal',
  staticDemoBannedChat: '/static-demo/banned-chat',
  staticDemoFAQ: '/static-demo/faq',
  staticDemoFAQInner: '/static-demo/faq-inner',
  staticDemoReleaseNotes: '/static-demo/release-notes',
};
